/**
 * toileSignInCard — Toile's own surface on the shared sign-in card (`@core/auth-ui/SignInCard`,
 * plan `2026_09_17_ovid_one_wall.md` § Decided 6). The stacked lockup, and the two pages this
 * house shelves its policy at. The card's own default copy and stylesheet are the ones Toile
 * shipped, so nothing else is stated here.
 */
import {ToileMark} from '@product/toile/components/ToileMark'

export const TOILE_SIGN_IN_CARD = {
    glyph: {mark: <ToileMark size={42} />, word: 'toile'},
    termsHref: '/terms',
    privacyHref: '/privacy',
}

/**
 * The words once a visitor holds a free take (operator, 2026-10-25; plan `2026_10_25_toile_first_take_free.md`
 * § Decided): one plain pair per trigger. A reader with no picture yet - the card opened before any take, say
 * because the free pick is spent elsewhere - keeps the shared words.
 */
export const TOILE_FREE_TAKE_COPY = {
    wall: {title: 'Sign in to make more', subtitle: 'Your first picture stays with your account.'},
    share: {title: 'Sign in to share a link', subtitle: 'The link opens this picture for anyone you send it to.'},
} as const

type ToileCard = typeof TOILE_SIGN_IN_CARD & {copy?: {title: string; subtitle: string}}

export function toileSignInCardFor({trigger, hasPicture}: {trigger: string; hasPicture: boolean}): ToileCard {
    if (!hasPicture) return TOILE_SIGN_IN_CARD
    if (trigger === 'wall') return {...TOILE_SIGN_IN_CARD, copy: TOILE_FREE_TAKE_COPY.wall}
    if (trigger === 'share') return {...TOILE_SIGN_IN_CARD, copy: TOILE_FREE_TAKE_COPY.share}
    return TOILE_SIGN_IN_CARD
}
